/**!
 * Created by Leonardo Cheslacki on 02/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import GamesController from './GamesController';

import WithType from './../helpers/WithType';

let _this = {};

const {default: {routes: {api, web}}, game: {pseudos}} = require('./../../../../config');

/**
 *
 */
class GamesCharacter extends GamesController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            activities: [],
            tracks: [],
            life: null,
            time_out: null,
            checked: [],
            answers: {}
        };

        this.$current_frame = 1;

        _this = this;
    };

    $functions = {
        handleButtonStart: function () {
            _this.$current_frame++;

            const _this_current = _this.get();

            /**
             *
             *  Stop the movie clip in frame.
             */
            _this.gotoAndStopFrame(_this_current, _this.$current_frame);

            _this.getHeart();

            _this.quizzesActivity();
        },

        handleButtonFinish: function () {
            const
                {disabled} = _this.state,
                {parent_id} = _this.props;

            !Boolean(disabled) && _this.main.redirectRoute(`${_this.$root_uri}/${web.uri_activity_levels}/${parent_id}`);
        },

        /**
         *
         * _id is a sprite.
         * @param event
         * @param btn_answer
         * @param answer
         * @param activity_id
         */
        handleButtonAnswer: function (event, {btn_answer, answer, activity_id}) {
            const
                {checked, life, disabled} = _this.state,
                {data_frames, delay_sequence} = _this.props,
                {occ_status, state: {clicked, _id}} = btn_answer,
                _this_current = _this.get(),
                _this_frame = _this.getFrame();

            if (!Boolean(clicked) && !Boolean(checked.length) && !Boolean(disabled)) {
                _this.setStateOccurrence(btn_answer, {clicked: true});

                !_this.inArray(checked, btn_answer) && checked.push(btn_answer);

                _this.setStates({answers: {[activity_id]: _id}});

                /**
                 * Find answer of ajax.
                 */
                const {template: {answer}} = _this.findActivity(_this.$current_frame);

                /**
                 * Change person face.
                 */
                _this.inObject(_this_frame, 'occ_sprite') && _this.gotoAndStopFrame(_this_frame.occ_sprite, _id);

                _this.setButtonMatte(btn_answer);

                _this.setBalloon(_id);

                _this.readAudioSay(_this.findAnswer(_this.$current_frame, _id), false, () => {
                    /**
                     * Compare answer template.
                     */
                    if (_this.valueObject(answer) === _id) {
                        /**
                         * Change status button, frame02 = yes.
                         */
                        _this.gotoAndStopFrame(occ_status, 2);

                        if (_this.$current_frame <= data_frames.length) {
                            _this.throttle('set-answers', _this.setAnswers(3, () => {
                                const {disabled} = _this.state;
                                if (!Boolean(disabled)) {
                                    _this.$current_frame++;
                                    _this.gotoAndStopFrame(_this_current, _this.$current_frame);
                                    _this.resetAnswers();
                                    _this.quizzesActivity();
                                }
                            }), delay_sequence);
                        } else {
                            _this.throttle('set-answers', () => {
                                _this.gotoAndStopFrame(_this_current, _this_current.totalFrames - 1);
                                _this.readAudioSay(_this.findTack('finish_out'));
                                this._handleButtonFinish && _this_current.btn_finish.off('mousedown', this._handleButtonFinish);
                                this._handleButtonFinish = _this_current.btn_finish.on('mousedown', _this.$functions.handleButtonFinish);
                            }, delay_sequence);
                        }
                    } else {
                        /**
                         * Change status button, frame03 = no.
                         */
                        _this.gotoAndStopFrame(occ_status, 3);

                        if (life <= 0) {
                            _this.throttle('set-answers', _this.setAnswers(4, _this.$functions.handleButtonFinish), delay_sequence);
                        } else {
                            _this.gotoAndStopFrame(_this_current.getChildByName(`occ_heart_${_this.padWithLeadingZeros(life, 2)}`).occ_animate_heart, 3);
                            _this.setState({..._this.state, life: (life - 1)});
                            _this.throttle('set-answers', _this.setAnswers(2, () => {
                                const {disabled} = _this.state;
                                !Boolean(disabled) && _this.resetAnswers();
                            }), delay_sequence);
                        }
                    }
                });
            } else {
                return _this.stopPropagation(event);
            }
        }
    };

    /**
     *
     * @param btn_answer
     */
    setButtonMatte = (btn_answer) => {
        for (let i = 0; i < pseudos.length; i++) {
            let pseudo = this.getPseudo(btn_answer, pseudos[i]);

            for (let property of pseudo.occ_animate_face.children) {
                if (this.inObject(property, 'occ_matte')) {
                    let {occ_matte} = property;
                    occ_matte.visible = !occ_matte.isVisible();
                }
            }
        }
    };

    /**
     *
     * @param _id
     */
    setBalloon = (_id = null) => {
        const _this_frame = this.getFrame();

        if (this.inObject(_this_frame, 'occ_balloon')) {
            for (let property of _this_frame.occ_balloon.children) {
                property.visible = this.toNumber(property.name) === this.toNumber(_id);
            }
        }
    };

    /**
     *
     * @param btn_answer
     * @param sprite
     * @param color
     */
    setButtonTemplate = (btn_answer, sprite, color) => {
        for (let i = 0; i < pseudos.length; i++) {
            let pseudo = this.getPseudo(btn_answer, pseudos[i]);

            for (let property of pseudo.occ_animate_face.children) {
                property.visible = (this.toNumber(property.name) === this.toNumber(sprite));
            }

            if (this.inObject(pseudo, 'occ_animate_color')) {
                for (let property of pseudo.occ_animate_color.children) {
                    property.visible = property.name.includes(color);
                }
            }
        }
    };

    quizzesActivity = () => {
        const
            _this_frame = this.getFrame(),
            data_frame = this.findDataFrame(this.$current_frame),
            {sprites, color} = data_frame,
            activity = this.findActivity(this.$current_frame),
            {template: {answer, activity_id}} = activity;

        let
            sprites_copy = [...sprites],
            answer_copy = {...answer},
            formatted_say_uri = this.verifyField(activity, 'formatted_say_uri');

        if (formatted_say_uri) {
            const btn_title = this.verifyField(_this_frame, 'btn_title');

            this.readAudioSay(activity, true);

            if (btn_title) {
                this._handleButtonTitle && btn_title.off('mousedown', this._handleButtonTitle);
                this._handleButtonTitle = btn_title.on('mousedown', this.$functionsAnimate.handlePlayAudio(activity));
            }
        }

        for (let i = 0; i < sprites.length; i++) {
            let
                sprite = sprites[i],
                btn_answer = _this_frame[`btn_answer_${this.padWithLeadingZeros((i + 1), 2)}`];

            sprite = this.randomArrayNoRepeat(sprites_copy);

            this.setButtonTemplate(btn_answer, sprite, color);

            this.setStateOccurrence(btn_answer, {_id: sprite, clicked: false});

            this[`_handleButtonAnswer${i}`] && btn_answer.off('mousedown', this[`_handleButtonAnswer${i}`]);
            this[`_handleButtonAnswer${i}`] = btn_answer.on('mousedown', this.$functions.handleButtonAnswer, false, false, {
                btn_answer: btn_answer,
                answer: answer_copy,
                activity_id: activity_id
            });
        }
    };

    resetAnswers = () => {
        const
            {checked} = this.state,
            {occ_response} = this.get(),
            _this_frame = this.getFrame(),
            occ_frame = this.getFrame(occ_response);

        /**
         * Reset for frame01 in layer null.
         */
        this.gotoAndStopFrame(occ_response, 1);
        this.gotoAndStopFrame(occ_frame, 1);

        this.inObject(_this_frame, 'occ_sprite') && this.gotoAndStopFrame(_this_frame.occ_sprite, 1);

        let length = checked.length

        for (let i = 0; length > i; i++) {
            this.gotoAndStopFrame(checked[i].occ_status, 1);

            this.setStateOccurrence(checked[i], {clicked: false});

            this.setButtonMatte(checked[i]);

            this.setBalloon();

            this.endFor(length, i) && this.setState({...this.state, checked: []});
        }
    };

    startCharacter = () => {
        const
            _this_current = this.get(),
            {btn_start, btn_out} = _this_current;

        this._handleButtonStart && btn_start.off('mousedown', this._handleButtonStart);
        this._handleButtonStart = btn_start.on('mousedown', this.$functions.handleButtonStart);

        this._handleButtonOut && btn_out.off('mousedown', this._handleButtonOut);
        this._handleButtonOut = btn_out.on('mousedown', this.$functions.handleButtonFinish);
    };

    initCharacter = () => {
        const {quiz_id} = this.props;

        this.gotoAndStopFrame(this.get(), this.$current_frame);

        this.main.getForm(`${this.$root_uri}/${api.api_activity_template}/${quiz_id}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({
                        ...this.state,
                        activities: this.verifyField(data, 'quiz.activities'),
                        tracks: this.verifyField(data, 'tracks'),
                        life: this.verifyField(data, 'quiz.life'),
                        time_out: this.verifyField(data, 'quiz.time')
                    }, this.startCharacter);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
GamesCharacter.propTypes = {
    current_name: PropTypes.string,
    data_frames: PropTypes.array,
    parent_id: PropTypes.number,
    quiz_id: PropTypes.number,
    delay_sequence: PropTypes.number,
    button_menu_game: PropTypes.array
};

/**
 *
 * @type {{}}
 */
GamesCharacter.defaultProps = {
    current_name: null,
    data_frames: [],
    parent_id: null,
    quiz_id: null,
    delay_sequence: 1000
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(GamesCharacter, {className: 'GamesCharacter'});
